export default "__VITE_ASSET__Br8XpiE6__"